import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedModule } from "@bt/shared";

import { CreateUserComponent } from './create-user.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    FontAwesomeModule
  ],
  declarations: [
    CreateUserComponent
  ],
})
export class CreateUserModule { }


// WEBPACK FOOTER //
// ./src/app/admin/create-user/create-user.module.ts